import forEach from 'lodash/forEach'
import map from 'lodash/map'
import { useLoadUsersLabels } from 'queries/users/useLoadUsers'
import * as React from 'react'

function useAvailableTeamUsers() {
  const { data: users, isUsersLoading } = useLoadUsersLabels()

  const buildAvailableTeamUsers = React.useCallback(
    () =>
      users
        ? map(users, (user) => ({
            value: user.id,
            label: user.email,
          }))
        : [],
    [users]
  )
  const [availableTeamUsers, setAvailableTeamUsers] = React.useState(
    buildAvailableTeamUsers
  )

  const buildAvailableTeamUsersMap = React.useCallback(() => {
    if (!users) {
      return {}
    }
    const usersMap = {}
    forEach(users, (user) => {
      usersMap[user.id] = { value: user.id, label: user.email }
    })
    return usersMap
  }, [users])
  const [availableTeamUsersMap, setAvailableTeamUsersMap] = React.useState(
    buildAvailableTeamUsersMap
  )

  React.useEffect(() => {
    setAvailableTeamUsers(buildAvailableTeamUsers)
  }, [buildAvailableTeamUsers])
  React.useEffect(() => {
    setAvailableTeamUsersMap(buildAvailableTeamUsersMap)
  }, [buildAvailableTeamUsersMap])

  return {
    availableTeamUsers,
    availableTeamUsersMap,
    isUsersLoading,
  }
}

export default useAvailableTeamUsers
